import { EEntityType, EDealType, EOrderField } from '../../types/filters';

export const SORT_TYPE_BUTTONS = [
  { label: 'По дате добавления в избранное', value: EOrderField.Added },
  { label: 'По цене', value: EOrderField.Price },
];

export const DEAL_TYPE_BUTTONS = [
  { label: 'Неважно', value: null },
  { label: 'Аренда', value: EDealType.Rent },
  { label: 'Продажа', value: EDealType.Sale },
];

export const FAVORITE_ENTITY_TYPE_BUTTONS = [
  { label: 'Неважно', value: null },
  { label: 'Жилая', value: EEntityType.Residential },
  { label: 'Загородная', value: EEntityType.Suburban },
  { label: 'Коммерческая', value: EEntityType.Commercial },
];
